import styled, { css } from 'styled-components/macro';
import {
  sidebarOpenedWidth,
  sidebarOpenedWidthLarge,
  sidebarClosedWidth
} from './Sidebar/SidebarStyles';

export const footerHeightMobile = '72px';
export const footerHeightDefault = '84px';
export const desktopHeaderHeight = '57px';
export const mobileHeaderHeight = '66px';
export const tabletHeaderHeight = '85px';

const layoutDivUnderlay = customValue => {
  const mobile = `${Number(customValue.mobileValue) + 6.6}rem`;
  const device = `${Number(customValue.defaultValue) + 8.5}rem`;
  return css`
    padding-top: ${mobile};
    @media screen and (min-width: 768px) {
      padding-top: ${device};
    }
    @media screen and (min-width: 1024px) {
      padding-top: 0;
    }
  `;
};

const contentDivUnderlay = customValue => {
  const mobileValue = `${-customValue.mobileValue}rem`;
  const defaultValue = `${-customValue.defaultValue}rem`;
  return css`
    @media screen and (max-width: 767px) {
      margin-top: ${mobileValue};
    }
    @media screen and (min-width: 768px) and (max-width: 1023px) {
      margin-top: ${defaultValue};
    }
  `;
};

const underlayDivBackground = customValue =>
  css`
    background-color: ${customValue.backgroundColor};
  `;

function matchRoute(props, route) {
  const matchRouteLength = props.currentRoute.length >= route.length;
  return props.currentRoute.includes(route) && matchRouteLength;
}

function configureRouteValue(props) {
  if (matchRoute(props, '/account/bank-account')) {
    return {
      mobileValue: '21',
      defaultValue: '21',
      backgroundColor: props.theme.concrete
    };
  } else if (matchRoute(props, '/account/crypto-wallets')) {
    return {
      mobileValue: '38',
      defaultValue: '27',
      backgroundColor: props.theme.concrete
    };
  } else if (matchRoute(props, '/account')) {
    return {
      mobileValue: '21',
      defaultValue: '21',
      backgroundColor: props.theme.concrete
    };
  } else {
    return {
      mobileValue: '0',
      defaultValue: '0',
      backgroundColor: props.theme.white
    };
  }
}

const addUnderlay = handleUnderlay => props => {
  const customValue = configureRouteValue(props);
  return handleUnderlay(customValue);
};

export const LayoutDiv = styled.div`
  position: relative;
  min-height: 100vh;
  margin-top: 0px;
  padding-top: ${mobileHeaderHeight};
  padding-bottom: ${footerHeightMobile};
  overflow: hidden;
  background-color: ${props => props.theme.white};

  @media screen and (min-width: 768px) {
    padding-bottom: ${footerHeightDefault};
  }

  @media screen and (min-width: 1024px) {
    padding-bottom: ${footerHeightDefault};
  }
  ${addUnderlay(layoutDivUnderlay)};
`;

export const UnderlayDiv = styled.div`
  @media screen and (max-width: 1023px) {
    ${addUnderlay(underlayDivBackground)};
    min-height: 76vh;
    padding-top: 1px;
  }
`;

export const ContentDiv = styled.div`
  @media screen and (max-width: 1023px) {
    position: relative;
    padding-bottom: 10rem;
  }
  ${addUnderlay(contentDivUnderlay)};
  @media screen and (min-width: 1024px) {
    margin-bottom: 11.5rem;
    min-height: calc(100vh - ${footerHeightDefault} - ${desktopHeaderHeight});
    padding-top: ${desktopHeaderHeight};
    ${props =>
      props.theme.sidebarOpened
        ? css`
            margin-left: ${sidebarOpenedWidth};
            @media screen and (min-width: 1440px) {
              margin-left: ${sidebarOpenedWidthLarge};
            }
          `
        : css`
            margin-left: ${sidebarClosedWidth};
          `}
  }
`;

// Footer styles
export const FooterDiv = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.concrete};
  height: ${footerHeightMobile};
  @media screen and (min-width: 768px) {
    height: ${footerHeightDefault};
  }
`;

const footerText = css`
  color: black;
  ${props => props.theme.fontStackHeader};
  font-weight: 400;
  font-size: 1.3rem;
  padding: 0 15px;
  text-align: center;
`;
export const CopyrightP = styled.p`
  ${footerText}
  @media screen and (max-width: 1023px) {
    font-size: 1.2rem;
  }
`;

export const SimpleLayoutDiv = styled.div`
  position: relative;
`;

export const SimpleContentDiv = styled.div`
  /* padding: 80px 0; */
  min-height: 100vh;
`;

export const SimpleLogoImg = styled.img`
  position: absolute;
  height: 20px;
  left: 20px;
  top: 25px;
  @media screen and (min-width: 768px) {
    left: 25px;
    height: 24px;
  }
`;

export const SimpleLayoutFooterH4 = styled.h4`
  position: absolute;
  bottom: 30px;
  text-align: center;
  letter-spacing: 0.04rem;
  width: 100%;
  @media screen and (min-width: 768px) {
    text-align: right;
    right: 50px;
  }
`;
